import { connect } from "react-redux";
import { css } from "emotion";
import Picture from "../../components/Picture";
import { Link } from "preact-router/match";
const imageCropper = css({
  width: 32,
  height: 32,
  position: "relative",
  overflow: "hidden",
  borderRadius: "50%"
});

const companyInfo = css({
  flexGrow: 1,
  display: "flex",
  marginTop: 4
});
const linkStyle = {
  color: "#196097",
  textDecoration: "underline"
};

const GiftCardPageHeader = ({
  giftCards,
  overrideHeaderColor,
  overrideTextColor,
  titleIsLink
}) => {
  const { giftCardPage } = giftCards;
  const { style, companyLogo, companyName, name, slug } = giftCardPage;
  const { headerColor, headerTextColor } = style;
  const headerStyle = css({
    width: "100%",
    position: "relative",
    backgroundColor: overrideHeaderColor ? overrideHeaderColor : headerColor,
    paddingLeft: 14,
    paddingRight: 14,
    paddingBottom: 16,
    paddingTop: 20,
    display: "flex",
    boxShadow: "0 0 1px 0 #f1f1f1, 0 1px 3px 0 rgba(9, 30, 66, 0.13)",
    zIndex: 100,
    "@media (max-width: 800px)": {
      display: "block",
      paddingTop: 12
    }
  });

  const textColor = overrideTextColor ? overrideTextColor : headerTextColor;
  const mainHeader = css({
    color: textColor,
    marginRight: 8,
    fontSize: 26,
    ...(titleIsLink ? linkStyle : {}),
    "@media (max-width: 800px)": {
      fontSize: 20,
      marginTop: 4,
      marginBottom: 0
    }
  });
  const header = <h1 className={mainHeader}>{name.toUpperCase()}</h1>;
  return (
    <div className={headerStyle}>
      <div className={companyInfo}>
        <CompanyLogo companyLogo={companyLogo} />
        <h2
          style={{
            color: textColor,
            marginTop: 4,
            marginLeft: 8,
            marginBottom: 0
          }}
        >
          {companyName}
        </h2>
      </div>
      {titleIsLink ? (
        <Link href={`/gift-cards/${slug}`}>{header}</Link>
      ) : (
        header
      )}
    </div>
  );
};

const CompanyLogo = ({ companyLogo }) => {
  if (!companyLogo || !companyLogo.handle) {
    return null;
  } else {
    return (
      <div className={imageCropper}>
        <Picture width={32} img={companyLogo} />
      </div>
    );
  }
};

export default connect(
  state => ({
    giftCards: state.giftCards
  }),
  {}
)(GiftCardPageHeader);



// WEBPACK FOOTER //
// ./routes/giftCards/GiftCardPageHeader.js